export default {
  PRIMARY_COLOR: '#303044',
  BG_COLOR: '#FCFDE0',
  PRIMARY_TEXT_COLOR: '#BA5267',
  SECONDARY_TEXT_COLOR: '#AE8998',
  SECONDARY_COLOR: '#38585B',
  WHITE: '#FFFFFF'
}


// WEBPACK FOOTER //
// ./src/shared/colors.js